import type {
  DeniedLoginLocation,
  FormData,
} from './use-denied-login-locations-form';

export const toFormData = (formData?: DeniedLoginLocation): FormData => {
  return {
    country: formData?.[0] ?? '',
  };
};
export const fromFormData = (formData: FormData): string => {
  return formData.country;
};
